import {Injectable, Injector} from '@angular/core';
import {BaseService} from '@twpub/core/services/base.service';
import {Observable, of, tap} from 'rxjs';
import {DomainTree} from '@twpub/core/models/domain-tree';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DomainService extends BaseService {
  private domainTreeCache = new Map<string, DomainTree>();

  constructor(injector: Injector) {
    super(injector);
  }

  public getDomainTree(dictIds: number[] | undefined): Observable<DomainTree> {
    if (!dictIds) {
      return of(new DomainTree());
    }
    const key = Array.from(dictIds).join(',')
    const cached = this.domainTreeCache.get(key);
    if (cached) {
      return of(cached);
    }
    return this.http.get<DomainTree>(this.url(`/domains/tree/${dictIds}`))
      .pipe(
        map(data => new DomainTree(data)),
        tap(domainTree => this.domainTreeCache.set(key, domainTree))
      );
  }
}
